import classNames from 'classnames';
import React from 'react';
import IconFont from '@meitu/xdesign-icon-font';
import { useConfig } from '@/configProvider';
import { ITeamIdentity, VipLevel, VipLevelIntl } from '@/types';
import { teamVip, userPrpVip, userVip, userXdesignPlusVip, userXdesignProVip } from '@/userInfo/constants/inedx';
import { getTeamTagType } from '../identitySwitch/shared';
import TeamLogo from '../teamLogo';
import { TeamTagType } from '../teamTag';
import './identityRow.less';

type IdentityRowSelectedIcon = React.FC<{ isSelected: boolean }>;

interface IIdentityItemProps {
    identity: ITeamIdentity;
    isSelected: boolean;
    onClick: () => void;
    /** 默认为 'TickIcon' */
    selectedIcon?: 'CheckBox' | 'TickIcon' | IdentityRowSelectedIcon;
    variant?: 'default' | 'dropdown';
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const IdentityRow_CheckBox: IdentityRowSelectedIcon = ({ isSelected }) => (
    <div className="IdentityRow_CheckBox" data-active={isSelected} />
);

const getStaticAssetSrc = (asset: any): string => (typeof asset === 'string' ? asset : asset?.src || '');

const IdentityRow: React.FC<IIdentityItemProps> = ({
    identity,
    isSelected,
    onClick,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    selectedIcon = 'TickIcon',
    variant = 'default',
}) => {
    const { isIntl } = useConfig();
    const teamType = getTeamTagType(identity.oid, identity.type);
    const isDropdown = variant === 'dropdown';
    // const Icon =
    //   selectedIcon === 'CheckBox'
    //     ? IdentityRow_CheckBox
    //     : selectedIcon === 'TickIcon'
    //     ? IdentityRow_TickIcon
    //     : selectedIcon;
    const Icon = ({ isSelected: active }: { isSelected: boolean }) =>
        active ? (
            <IconFont
                fontSize={16}
                name="CheckBold"
                color={isDropdown ? 'var(--content-system-primary, #1C1D1F)' : 'var(--content-system-link, #3388FF)'}
            />
        ) : null;
    return (
        <div
            className={classNames('IdentityRow', {
                'IdentityRow-dropdown': isDropdown,
            })}
            data-identity-type={identity.type}
            data-active={isSelected}
            onClick={onClick}
        >
            <div className="IdentityRow-left">
                <div className="IdentityRow-avatar">
                    <TeamLogo src={identity.logo} size="medium" name={identity.name} oid={identity.oid} />
                </div>
                <div className="IdentityRow-infoBox">
                    <div className="IdentityRow-infoBox-top">
                        <div className="IdentityRow-name">{identity.alias || identity.name}</div>
                        <div className="IdentityRow-teamTag">
                            {identity.groups[0]?.is_vip && (
                                <img
                                    src={
                                        identity.type === 0
                                            ? isIntl
                                                ? identity.groups[0]?.vip_level === VipLevelIntl.Pro
                                                    ? userXdesignProVip
                                                    : userXdesignPlusVip
                                                : identity.groups[0]?.vip_level === VipLevel.ProCn
                                                  ? userPrpVip
                                                  : userVip
                                            : getStaticAssetSrc(teamVip)
                                    }
                                    style={identity.type === 0 ? { height: 16 } : { width: 45, height: 14 }}
                                    alt=""
                                />
                            )}
                        </div>
                    </div>
                    <div className="IdentityRow-detailInfo">
                        <IconFont name={teamType === TeamTagType.personal ? 'User' : 'Enterprise'} fontSize={12} />
                        <span className="IdentityRow-memberNum">
                            {teamType === TeamTagType.personal ? 1 : identity.member_num}人
                        </span>
                    </div>
                </div>
            </div>
            <div className="IdentityRow-selectedIcon">
                <Icon isSelected={isSelected} />
            </div>
        </div>
    );
};

export default IdentityRow;
